import { useLayoutEffect, useRef } from 'react';

export default function SessionChangedNotice() {
    const dialogRef = useRef(null);
    useLayoutEffect(() => {
        const dialog = dialogRef.current;
        dialog.showModal();
        return () => dialog.close();
    }, []);

    return (
        <dialog ref={dialogRef} onCancel={event => event.preventDefault()}
            aria-labelledby="session-changed-title" aria-describedby="session-changed-description"
            className="pointer-events-auto m-auto w-full max-w-lg rounded-xl border border-slate-200 bg-white p-6 text-slate-900 shadow-xl backdrop:bg-slate-950/60">
            <h2 id="session-changed-title" className="mb-3 text-xl font-semibold">Your session changed in another tab</h2>
            <div id="session-changed-description" className="space-y-3 text-sm text-slate-600">
                <p>Another tab signed in or out, or this tab no longer matches the current session. New requests from this tab are blocked to prevent saving under the wrong account.</p>
                <p>Reload to use the current session. Unsaved entries in this tab will be discarded. A save sent before the session changed may already have completed; check your records before entering it again.</p>
                <p>To use different accounts at the same time, open them in separate browser profiles.</p>
            </div>
            <button type="button" onClick={() => window.location.reload()}
                className="mt-5 rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-900">
                Reload and discard unsaved entries
            </button>
        </dialog>
    );
}
